import { render, staticRenderFns } from "./trans_apply.vue?vue&type=template&id=8ada7f7a"
import script from "./trans_apply.vue?vue&type=script&lang=js"
export * from "./trans_apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports